export default {
  clearFilters() {
    this.$patch({
      page: {
        all: 1,
        outlet: 1,
        influencer: 1,
      },
      totalContacts: 0,
      selectedIds: [],
      keywordQuery: "",
      keywordOutletFields: ["name_analysed"],
      keywordInfluencerFields: ["name_analysed"],
      ignoreDefaultCountryFilters: false,
      scrollTop: 0,
      filterLocations: [],
      filterTalkingAboutTags: [],
      filterTalkingAboutOperator: "AND",
      filterTargetAreas: [],
      filterTopics: [],
      filterLanguages: [],
      filterSocials: [],
      filterCoverages: [],
      filterMediaTypes: [],
      filterCirculation: {
        enabled: false,
        gte: null,
        lte: null,
      },
      filterFrequencies: [],
      filterContentTypes: [],
      filterDesignatedMarketAreas: [],
    });
  },
  addSelectedIds(ids) {
    const selectedIds = new Set(this.selectedIds);
    ids.forEach((id) => selectedIds.add(id));
    this.selectedIds = Array.from(selectedIds);
  },
  removeSelectedIds(ids) {
    const selectedIds = new Set(this.selectedIds);
    ids.forEach((id) => selectedIds.delete(id));
    this.selectedIds = Array.from(selectedIds);
  },
  setSearchTab(tab) {
    this.searchTab = tab;
  },
  setSortBy(sortBy) {
    this.sortBy = sortBy;
  },
  setSortDirection(sortDirection) {
    this.sortDirection = sortDirection;
  },
  setTabSortBy(sortBy) {
    this.sortBy[this.searchTab] = sortBy;
  },
  setInfluencerTabSortBy(sortBy) {
    this.sortBy.influencer = sortBy;
  },
  setTabSortDirection(sortDirection) {
    this.sortDirection[this.searchTab] = sortDirection;
  },
  setPage(page) {
    this.page = page;
  },
  setPagination({ page, pageSize }) {
    this.$patch({
      page,
      pageSize,
    });
  },
  setTabPagination({ page, pageSize }) {
    this.page[this.searchTab] = page;
    this.pageSize[this.searchTab] = pageSize;
  },
  setTotalContacts(totalContacts) {
    this.totalContacts = totalContacts;
  },
  addFilterTopic(topic) {
    const foundTopic = this.filterTopics.find(
      (existingTopic) => existingTopic.id === topic.id
    );

    if (foundTopic) return;

    this.filterTopics = [...this.filterTopics, topic];
    this.scrollTop = 0;
    this.page = 1;
  },
  setFilterLocations(locations) {
    this.filterLocations = locations;
  },
  removeFilterLocation(location) {
    this.filterLocations = this.filterLocations.filter(
      (filterLocation) => filterLocation.id !== location.id
    );
  },
  setFilterTargetAreas(targetAreas) {
    this.filterTargetAreas = targetAreas;
  },
  removeFilterTargetArea(targetArea) {
    this.filterTargetAreas = this.filterTargetAreas.filter(
      (filterTargetArea) => filterTargetArea.id !== targetArea.id
    );
  },
  setFilterTopics(topics) {
    this.filterTopics = topics;
  },
  removeFilterTopic(topic) {
    this.filterTopics = this.filterTopics.filter(
      (existingTopic) => existingTopic.id !== topic.id
    );
  },
  setFilterDesignatedMarketAreas(designatedMarketAreas) {
    this.filterDesignatedMarketAreas = designatedMarketAreas;
  },
  removeFilterDesignatedMarketArea(dma) {
    this.filterDesignatedMarketAreas = this.filterDesignatedMarketAreas.filter(
      (existingDesignatedMarketArea) =>
        existingDesignatedMarketArea.id !== dma.id
    );
  },
  setFilterLanguages(languages) {
    this.filterLanguages = languages;
  },
  removeFilterLanguage(language) {
    this.filterLanguages = this.filterLanguages.filter(
      (outletLanguage) => outletLanguage !== language
    );
  },
  removeFilterTalkingAboutTag(tagIndex) {
    this.filterTalkingAboutTags.splice(tagIndex, 1);
  },
  setFilterSocials(socials) {
    this.filterSocials = socials;
  },
  removeFilterSocial(social) {
    this.filterSocials = this.filterSocials.filter(
      (filterSocial) => filterSocial !== social
    );
  },
  setFilterCoverages(coverages) {
    this.filterCoverages = coverages;
  },
  removeFilterCoverages(coverage) {
    this.filterCoverages = this.filterCoverages.filter(
      (filterCoverage) => filterCoverage !== coverage
    );
  },
  setFilterMediaTypes(mediaTypes) {
    this.filterMediaTypes = mediaTypes;
  },
  removeFilterMediaType({ id }) {
    this.filterMediaTypes = this.filterMediaTypes.filter(
      (mediaType) => mediaType.id !== id
    );
  },
  resetFilterCirculation() {
    this.filterCirculation.enabled = false;
    this.filterCirculation.gte = null;
    this.filterCirculation.lte = null;
  },
  setFilterCirculation({ gte, lte }) {
    let enabled = false;

    if (gte?.length || lte?.length) {
      enabled = true;
    }

    Object.assign(this.filterCirculation, {
      enabled,
      gte,
      lte,
    });
  },
  setFilterFrequencies(frequencies) {
    this.filterFrequencies = frequencies;
  },
  removeFilterFrequency(frequency) {
    this.filterFrequencies = this.filterFrequencies.filter(
      (filterFrequency) => filterFrequency !== frequency
    );
  },
  setFilterContentTypes(contentTypes) {
    this.filterContentTypes = contentTypes;
  },
  removeFilterContentType(contentType) {
    this.filterContentTypes = this.filterContentTypes.filter(
      (filterContentType) => filterContentType !== contentType
    );
  },
  setSelectedIds(selectedIds) {
    this.selectedIds = selectedIds;
  },
  setKeywordQuery(query) {
    this.keywordQuery = query;
  },
  setKeywordInfluencerFields(fields) {
    this.keywordInfluencerFields = fields;
  },
  setKeywordOutletFields(fields) {
    this.keywordOutletFields = fields;
  },
  setIgnoreDefaultCountryFilters(ignore) {
    this.ignoreDefaultCountryFilters = ignore;
  },
  setScrollTop(scrollTop) {
    this.scrollTop = scrollTop;
  },
  setFilterTalkingAboutTags(tags) {
    this.filterTalkingAboutTags = tags;
  },
  setFilterTalkingAboutOperator(operator) {
    this.filterTalkingAboutOperator = operator;
  },
};
